import React from 'react';
import RestaurantLandingPage from '../modules/restaurant/components/RestaurantLandingPage';

const RestaurantPage = () => {
  return <RestaurantLandingPage />;
};

export default RestaurantPage;
